import Hashids from 'hashids';
export default {install (Vue)
    {
      const libhashids = {
          Codifica(dato){
            const hashids = new Hashids(this.RellenoHashidsApis());
            const encriptado = hashids.encode(dato);
            return encriptado;
          },
          Decodifica(dato){
            const hashids = new Hashids(this.RellenoHashidsApis());
            const valorOriginal = hashids.decode(dato);
            return valorOriginal;
          },
          RellenoHashidsApis(){
            return 'hindstramitelargodecontextoapi'
          }
        }
        Vue.prototype.$libhashids = libhashids;
      }
    }
